import { Controller } from "@hotwired/stimulus"

/**
 * Controls the import wizard footer's submit button state based on file upload events.
 *
 * This controller listens for window-level custom events dispatched by file_dropzone_controller
 * and enables/disables the submit button based on the upload state.
 */
export default class WizardFooterController extends Controller {
  static targets = ["submitButton"]

  declare submitButtonTarget: HTMLButtonElement
  declare hasSubmitButtonTarget: boolean

  validateFileUpload(event: CustomEvent<{ uploading: boolean; hasComplete: boolean; requireUpload: boolean }>) {
    if (!this.hasSubmitButtonTarget) return

    const { uploading, hasComplete, requireUpload } = event.detail

    if (uploading) {
      this.submitButtonTarget.disabled = true
    } else if (requireUpload) {
      this.submitButtonTarget.disabled = !hasComplete
    } else {
      this.submitButtonTarget.disabled = false
    }
  }
}
